import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FilterListIcon from '@material-ui/icons/FilterList';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import {toBool} from 'data/converter';
import styles from './CollectionCaseHeader.module.sass';
import UserChange from 'components/common/UserChange';
import {FAST_FILTER_UPDATED_TODAY, FAST_FILTER_DEFAULT, FAST_FILTER_MONITORING} from './fastFilters';

const mapStateToProps = state => ({
  dicts: state.dictionary
});

@connect(mapStateToProps)
class CollectionCaseHeader extends PureComponent {
  handleFilterButtonOnClick = () => {
    let {value: {sort, filter}, onChange, visibleFilter} = this.props;
    if (sort) sort.desc = toBool(sort.desc);

    const newFilter = visibleFilter ? null : (filter || {});
    if(onChange) onChange({filter: newFilter, sort});
  };

  handleOnChange = (value) => {
    const {onChange} = this.props;
    if (onChange) onChange(value);
  };

  render() {
    let {value: {filter = {}}, className, visibleFilter} = this.props;

    return (
        <Toolbar className={cx(styles.header, className)}>
          <div className={styles.headerLeftBox}>
            <Typography className={styles.title}>
              Рабочее место коллектора
            </Typography>
            <UserChange/>
          </div>
          <div className={styles.headerRightBox}>
            <div>
              <FormControlLabel
                control={
                  <Radio
                    checked={filter.type === FAST_FILTER_DEFAULT.filter.type}
                    onChange={() => this.handleOnChange(FAST_FILTER_DEFAULT)}
                  />}
                label={'По умолчанию'}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={filter.type === FAST_FILTER_UPDATED_TODAY.filter.type}
                    onChange={() => this.handleOnChange(FAST_FILTER_UPDATED_TODAY)}
                  />}
                label={'Обновлены сегодня'}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={filter.type === FAST_FILTER_MONITORING.filter.type}
                    onChange={() => this.handleOnChange(FAST_FILTER_MONITORING)}
                  />
                }
                label={'Мониторинг'}
              />
            </div>
            <Tooltip title={visibleFilter ? 'Удалить фильтр' : 'Фильтр'}>
              <IconButton onClick={() => {
                this.handleFilterButtonOnClick();
              }}>
                {!visibleFilter
                  ? <FilterListIcon/>
                  : <DeleteSweepIcon/>
                }
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
    );
  }
}

CollectionCaseHeader.propTypes = {
  className: PropTypes.string,
  visibleFilter: PropTypes.bool,
  value: PropTypes.objectOf({
    filter: PropTypes.object,
    sort: PropTypes.object,
  }),

  onChange: PropTypes.func
};

export default CollectionCaseHeader;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCase/CollectionCaseHeader.jsx